module.exports = __webpack_public_path__ + "media/images/flags/ly-5b82a613fbad2854ca251ab446711215.svg";